import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { FeatureToggle } from './featureToggles'

export const sandboxAccessControl: DomainAccessControlConfig = [
  { warehouseFeatureToggles: [FeatureToggle.sfpSandboxVisible], restrictedBannersAllowed: true },
  { featureToggles: [FeatureToggle.sfpSandboxUserVisible], restrictedBannersAllowed: true },
]
